import * as types from '../types';
const userWorkbookDeleted = workbookId => ({
  type: types.USER_WORKBOOK_DELETED,
  workbookId
});
export default userWorkbookDeleted;